import { Chip } from "@mui/material"
import type { FC } from "react"

import { SALES_OPPORTUNITY_STATUS_TO_CLASS_NAME, SALES_OPPORTUNITY_STATUS_TO_LABEL } from "../constants"

import type { SalesPipelineStatusGql } from "@/graphql/codegen/graphql"

interface SalesOpportunityStatusChipProps {
  status: SalesPipelineStatusGql
}

export const SalesOpportunityStatusChip: FC<SalesOpportunityStatusChipProps> = ({ status }) => (
  <Chip
    label={SALES_OPPORTUNITY_STATUS_TO_LABEL[status]}
    size='small'
    className={`rounded-sm ${SALES_OPPORTUNITY_STATUS_TO_CLASS_NAME[status]}`}
    data-testid={`sales-opportunity.status-chip.${status.toLowerCase()}`}
  />
)
